// Keeps the "--announcement-bar-height" custom property on <body> in sync with the
// actual rendered height of the sticky announcement bar, so the sticky header (see
// sections/header.liquid) knows how far down to stick, without overlapping the banner.
// Works the same way the theme's own header.js keeps "--header-height" up to date.

function initStickyAnnouncementBar() {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;

  const setHeight = () => {
    const height = Math.round(bar.getBoundingClientRect().height);
    document.body.style.setProperty('--announcement-bar-height', `${height}px`);
  };

  setHeight();

  if ('ResizeObserver' in window) {
    new ResizeObserver(setHeight).observe(bar);
  } else {
    window.addEventListener('resize', setHeight);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyAnnouncementBar);
} else {
  initStickyAnnouncementBar();
}
